import { WlProfilesToolbarEventTypeEnum } from '../../shared/container/toolbars/module/profiles/broadcast/toolbar-profiles-broadcast-event-type.enum';
import { WlProfilesToolbarEvent } from '../../shared/container/toolbars/module/profiles/broadcast/toolbar-profiles-broadcast-event.model';
import { WlProfilesToolbarBroadcastService } from '../../shared/container/toolbars/module/profiles/broadcast/toolbar-profiles-broadcast.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { UtilService, NotificationService, DialogService, TranslationService, LocalStorageService } from '../../shared/index'; //app/shared/index barrel;
import { NavigationService } from '../../shared/navigation/navigation.service';
import { ProfileSearchService } from '../search/index';
import { ProfileSearchComponent } from '../search/profile-search.component';
import { ProfileSearchComponentModel } from '../search/profile-search-component.model';
import { ProfileMin } from '../shared/profile-min.model';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-finder',
  templateUrl: 'profile-finder.component.html',
  providers: [ProfileSearchService],
    standalone: false
})
export class ProfileFinderComponent implements OnInit, OnDestroy {
  private _utilService: UtilService;
  private _notifyService: NotificationService;
  private _translationService: TranslationService;
  private _dialogService: DialogService;
  private _navigationService: NavigationService;
  private _profileSearchService: ProfileSearchService;
  private _route: ActivatedRoute;
  public _subscriptions: Array<Subscription> = [];

  @ViewChild('profileSelectorComponent', { static: false }) _profileSearchComponent: ProfileSearchComponent;

  public profileSearchComponentModel: ProfileSearchComponentModel;

  public constructor(
    utilService: UtilService,
    notifyService: NotificationService,
    translationService: TranslationService,
    dialogService: DialogService,
    navigationService: NavigationService,
    profileSearchService: ProfileSearchService,
    route: ActivatedRoute,
    private _profileBroadcast: WlProfilesToolbarBroadcastService,
    private _localStorageService: LocalStorageService
  ) {
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._dialogService = dialogService;
    this._navigationService = navigationService;
    this._profileSearchService = profileSearchService;
    this.profileSearchComponentModel = new ProfileSearchComponentModel();
    this._route = route;
  }

  ngOnInit(): void {
    // watch for passed in query params
    this._subscriptions.push(
      this._route.queryParams.subscribe((params: Params) => {
        if (params && params['q']) {
          this._profileSearchComponent.profileSearchComponentModel.searchParams.Keyword = params.q;
          this._profileSearchComponent.searchProfiles();
        } else if (params && this._utilService.getObjectPropertyValueCaseInsensitive(params, 'newProfile')) {
          this._profileBroadcast.broadcast(new WlProfilesToolbarEvent(WlProfilesToolbarEventTypeEnum.newProfile));
        }
      })
    );
  }

  ngOnDestroy(): void {
    if (this._subscriptions) this._subscriptions.forEach((s) => s.unsubscribe());
  }

  public profileSelected = ($event: ProfileMin) => {
    let profileId = $event.ProfileId;
    this._navigationService.navigateToProfileView(profileId, true);
  };
}
